module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Bear Hunting")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("By R.W. Clinger")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('a', {
    attrs: {
      "id": "a4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005#a61"
    }
  }, [_vm._v("Part 1: Blue Danning")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/005#a62"
    }
  }, [_vm._v("Chapter 1: Bear Blog, March 28")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/006#a63"
    }
  }, [_vm._v("Chapter 2: April Fool’s Day")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/007#a64"
    }
  }, [_vm._v("Chapter 3: What Blue Doesn’t Know")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/008#a65"
    }
  }, [_vm._v("Chapter 4: King’s Barbells and Boxing")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/009#a66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: When A Stranger Calls")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/010#a67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Cliffy’s Cafe")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/011#a68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Bear’s Den")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/012#a69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Show Me Your Chest")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/013#a70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Memorabilia")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/014#a71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Bear Blog, April 4")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    attrs: {
      "href": "#/015#a72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2: Grant Stevens")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/015#a73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: The Whiskey Club")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/016#a74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: The Musician")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/017#a75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: A Drink on Me")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/018#a76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Homework on You")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/019#a77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Walk this Road Tonight")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/020#a78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Beautiful Bodies")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/021#a79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Lay with Me Awhile")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/022#a80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: It’s Alright…Alright")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/023#a81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Blue Visits")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/024#a82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Bear Blog, May 6")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    attrs: {
      "href": "#/025#a83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3: Denver Rawlston")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/025#a84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Bump Into His Skin")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/026#a85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Holiday Proposition")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/027#a86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: On Bretton Way")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/028#a87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: What Toby Does")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/029#a88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: What Toby Reads")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/030#a89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: What Toby Watches")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/031#a90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: What Toby Continues to Watch")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/032#a91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: Muddled")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/033#a92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: Getting to Know Denver")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/034#a93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30: Bear Blog, August 1")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    attrs: {
      "href": "#/035#a94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 4: Carey Cunningham")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/035#a95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31: He’s Maybe Mr. Right")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/036#a96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32: Body Parts")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/037#a97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33: King Time")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/038#a98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34: Bear Blog, August 15")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/039#a99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: Breaking Rules")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/040#a100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36: The Final Piece of the Puzzle")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/041#a101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37: This Can’t Be Happening")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/042#a102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38: Minding Matters")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/043#a103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39: Nothing Happened")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/044#a104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40: Bear Blog, August 28")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    attrs: {
      "href": "#/045#a105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 5: Jim Bone")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/045#a106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 41: Millard LeCarre")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/046#a107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 42: The Bear’s Den")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/047#a108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 43: The Favor")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/048#a109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 44: Uninterested")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/049#a110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 45: Ending Things like Polite Men")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/050#a111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 46: Sunlight")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/051#a112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 47: Bear Blog, Jim Bone 1")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/052#a113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 48: A Late Evening Visit")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/053#a114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 49: Sometimes You Can’t Help Who You Fall For")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/054#a115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 50: Fool")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    attrs: {
      "href": "#/055#a116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: December 20")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "p0"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df7843c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004.vue
// module id = 63
// module chunks = 0